/**
 * SocialCheckoutRedirect.js — Redirect social ad traffic to embedded checkout.
 * Routes: /individual-social, /family-social
 *
 * When a Meta/social ad links to /individual-social or /family-social,
 * this component fires the InitiateCheckout pixel event and redirects
 * to the embedded checkout page. Ad URLs stay the same — only the
 * destination changes (embedded form instead of Stripe hosted).
 */

import { useEffect } from 'react';

export default function SocialCheckoutRedirect({ planType }) {

  useEffect(() => {
    // Fire Meta InitiateCheckout pixel event
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: planType === 'individual' ? 'Individual Plan' : 'Family Plan',
        value: planType === 'individual' ? 297.00 : 397.00,
        currency: 'USD'
      });
    }

    // Redirect to embedded checkout
    window.location.href = `/checkout-social?plan=${planType}`;
  }, [planType]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      background: '#F5F2EA',
    }}>
      <div style={{ textAlign: 'center', padding: 40 }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>🔒</div>
        <p style={{ fontSize: 16, color: '#565C66' }}>Redirecting to secure checkout...</p>
      </div>
    </div>
  );
}